// extracted by mini-css-extract-plugin
export var completionBody = "_cf-2";
export var completionCard = "_cf-0";
export var completionFooter = "_cf-3";
export var completionTitle = "_cf-1";